import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AlmaMaterialModule } from './ui-libraries/alma-material/alma-material.module';
import { AlmaExUiModule } from './ui-libraries/alma-ex-ui/alma-ex-ui.module';


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    AlmaMaterialModule,
    AlmaExUiModule
  ]
})
export class CoreModule { }
